import { render, staticRenderFns } from "./PageSubnavTabs.vue?vue&type=template&id=7d5fc078&"
import script from "./PageSubnavTabs.vue?vue&type=script&lang=js&"
export * from "./PageSubnavTabs.vue?vue&type=script&lang=js&"
import style0 from "./PageSubnavTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports